import { createTextComponent } from './createTextComponent';

export const H1 = createTextComponent({
  styleAs: 'h1',
  tag: 'h1',
});
